import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a7bf20c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-verification-view d-flex justify-content-center py-4 py-md-5" }
const _hoisted_2 = { class: "col-12 col-lg-11 col-xl-9 col-xxl-7" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap col-12 align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title" }, [
  /*#__PURE__*/_createTextVNode("Register: "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode("Step 4 of 4"),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h1 class=\"mb-0 mt-2 h2\" data-v-4a7bf20c>Verification Email Sent!</h1><div class=\"form py-3 py-lg-5\" data-v-4a7bf20c><div class=\"col-12\" data-v-4a7bf20c><p class=\"blurb\" data-v-4a7bf20c>Thank you for registering.</p><p class=\"blurb\" data-v-4a7bf20c>A confirmation email has been sent to your email address for verification. Please click the link in the email to verify your email address and complete registration.</p></div></div>", 2)
const _hoisted_9 = [
  _hoisted_7
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "mb-0 mt-2 h2" }
const _hoisted_12 = {
  key: 0,
  class: "form py-3 py-lg-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "blurb" }, "Thank you. Taking you to the login page…", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "form py-3 py-lg-5"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "blurb" }, "Please wait. Email verification in process...", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "form py-3 py-lg-5"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "blurb" }, "This link is no longer valid. Log in and we'll send you a new one.", -1))
const _hoisted_20 = { class: "pt-2 pt-md-3" }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = {
  class: "form pb-3 pb-lg-5",
  style: {"min-height":"40vh"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "blurb" }, "You seem to have arrived at this page in error.", -1))
const _hoisted_24 = { class: "pt-2 pt-md-3" }

import { useHead } from "@unhead/vue";
import { onBeforeMount, onMounted, reactive, ref, Ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useMiscStore } from "@/stores/misc";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { handleError } from "@/utilities/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerificationView',
  setup(__props) {

useHead({
  title: "Email Verification",
});

const authStore = useAuthStore();
const miscStore = useMiscStore();
const route = useRoute();
const router = useRouter();
let code: Ref<string | null> = ref(null);
let userId: Ref<string | null> = ref(null);
let done: Ref<boolean> = ref(false);
let errors: Ref<boolean> = ref(false);
const confirmed = ref(false);

onBeforeMount(() => {
  if (route.query.code != null) {
      code.value = decodeURI(route.query.code as string);
    }

    if(route.query.userId) {
      userId.value = route.query.userId as string
    }

    if (route.query.sent == 'success') {
      done.value = true;
    }
})

onMounted(() => {
  errors.value = false;
  if(code.value && userId.value) {
    authStore.emailVerification({userId: userId.value, code: code.value}).then(() => {
      // Long enough to read before the login page replaces it.
      confirmed.value = true;
      ElMessage.success({ message: "Your email is confirmed. Please log in.", showClose: true, duration: 0 });
      setTimeout(() => router.push({ name: 'Login' }), 3000);
    }).catch((error:any) => {
      handleError(error);
      errors.value = true;
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(errors) && (_unref(done) || (_unref(code) && _unref(userId))))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (_unref(done))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
        : (_unref(code) && _unref(userId))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h1", _hoisted_11, _toDisplayString(confirmed.value ? "Your email is confirmed" : "Verifying your email"), 1),
              (confirmed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                : (!_unref(errors))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_router_link, { to: "/" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Return")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Return")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
    ])
  ]))
}
}

})